import { DatePicker } from 'antd';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

export type DateRange = [Dayjs, Dayjs] | null;

interface DateRangePickerProps {
  value?: DateRange;
  onChange?: (range: DateRange) => void;
}

// Presets required by the dashboard/reports: today / last 7 / last 30 days (architecture §4.5, Q4).
// Resolve relative dates when selected, even if this tab has remained open past midnight.
const recentDays = (days: number): [Dayjs, Dayjs] => {
  const now = dayjs();
  return [now.add(1 - days, 'day').startOf('day'), now.endOf('day')];
};
const presets: { label: string; value: () => [Dayjs, Dayjs] }[] = [
  { label: 'امروز', value: () => recentDays(1) },
  { label: '۷ روز اخیر', value: () => recentDays(7) },
  { label: '۳۰ روز اخیر', value: () => recentDays(30) },
];

export default function DateRangePicker({ value, onChange }: DateRangePickerProps) {
  return (
    <RangePicker
      presets={presets}
      value={value}
      onChange={(range) => {
        if (range && range[0] && range[1]) onChange?.([range[0].startOf('day'), range[1].endOf('day')]);
        else onChange?.(null);
      }}
    />
  );
}
